import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Web3ReactProvider } from '@web3-react/core';
import { ethers } from 'ethers';
import { Toaster } from 'react-hot-toast';
import Layout from '../components/Layout';

import * as ga from '../lib/ga';

// import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/globals.scss';

function getLibrary(provider) {
  return new ethers.providers.Web3Provider(provider);
}

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    const pageview = (url) => {
      ga.pageview(url);
    };

    router.events.on('routeChangeComplete', pageview);

    return () => {
      router.events.off('routeChangeComplete', pageview);
    };
  }, [router]);

  return (
    <>
      <Head>
        <title>Noundles</title>
        <meta
          name="description"
          content="A community-led PFP collection inspired by @nounsdao with some smoothed out funk. Passive staking for 4 $Rainbows/day. Not affiliated with any other project."
          key="description"
        />
        <link rel="icon" href="/favicon.ico" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.noundles.io" />
        <meta property="og:title" content="Noundles" key="og:title" />
        <meta
          property="og:description"
          content="A community-led PFP collection inspired by @nounsdao with some smoothed out funk. Passive staking for 4 $Rainbows/day. Not affiliated with any other project."
          key="og:description"
        />
        <meta
          property="og:image"
          content="https://www.noundles.io/banner.png"
          key="og:image"
        />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.noundles.io" />
        <meta property="twitter:title" content="Noundles" key="twitter:title" />
        <meta
          property="twitter:description"
          content="A community-led PFP collection inspired by @nounsdao with some smoothed out funk. Passive staking for 4 $Rainbows/day. Not affiliated with any other project."
          key="twitter:description"
        />
        <meta
          property="twitter:image"
          content="https://www.noundles.io/banner.png"
          key="twitter:image"
        />
      </Head>

      <Web3ReactProvider getLibrary={getLibrary}>
        <Layout>
          <Component {...pageProps} />
          <Toaster />
        </Layout>
      </Web3ReactProvider>
    </>
  );
}

export default MyApp;
